import { createNotificationInDb } from "./notificationService";
import { NotificationFormData } from "@/types/notifications";
import { BulkOrderEntry } from "@/hooks/useBulkOrderProducts";

export interface BulkResult {
  success: boolean;
  voNumbers: string[];
  error?: string;
}

export const createBulkNotification = async (
  entries: BulkOrderEntry[],
  userId: string,
  userName: string
): Promise<BulkResult> => {
  try {
    // Combine all VO numbers into comma-separated string
    const combinedVoNumber = entries.map(e => e.voNumber).join(", ");

    // Combine all products from all entries
    const allProducts = entries.flatMap(e =>
      e.products.map(p => ({
        ...p,
        productMessage: e.message,
      }))
    );

    // Use shared message/type/status from first entry (all should be identical via autofill)
    const firstEntry = entries[0];

    const formData: NotificationFormData = {
      type: firstEntry.type,
      voNumber: combinedVoNumber,
      exactOrderNumber: "",
      message: firstEntry.message,
      priority: "normaal",
      userId,
      userName,
      status: firstEntry.status,
      recipients: {
        internal: { group1: false, group2: false },
        external: [],
      },
      selectedOrderProducts: allProducts.length > 0 ? allProducts : undefined,
      isOverarchingNotification: true,
    };

    await createNotificationInDb(formData);
    return { success: true, voNumbers: entries.map(e => e.voNumber) };
  } catch (err: any) {
    console.error("Bulk create failed:", err);
    return { success: false, voNumbers: entries.map(e => e.voNumber), error: err.message };
  }
};
